export default __webpack_public_path__ + "static/media/logo.56d6b101.jpeg";